import { Typography } from '@mui/material';

const PageTitle: React.FC = ({ children }) => (
  <Typography variant="h5" component="h5" sx={{ mb: 5 }} fontWeight={200}>
    {children}
  </Typography>
);

export default PageTitle;
